/**
 * Bascule V1 / V2 du panneau simulation travaux (variant admin).
 *
 * Lit GET /api/v1/scenarios-panel-variant (public, cache 5 min) :
 *   - "v1" (défaut) → ScenariosPanel historique (bouquets + cartes)
 *   - "v2"          → ScenariosPanelV2 (tableau de synthèse + sélection)
 * Bascule immédiate depuis /admin/scenarios-panel-variant, sans
 * redéploiement ; en cas d'échec réseau, retombe sur V1.
 */

import { useQuery } from "@tanstack/react-query";
import { getPanelVariant } from "@/api/site";
import { ScenariosPanel } from "@/components/dpe/ScenariosPanel";
import { ScenariosPanelV2 } from "@/components/dpe/scenariosV2/ScenariosPanelV2";
import type { ScenariosPanelV2Props } from "@/components/dpe/scenariosV2/ScenariosPanelV2";

type GateProps = {
  logementId: string;
  currentLabel: string;
} & ScenariosPanelV2Props;

export function ScenariosPanelGate(props: GateProps) {
  const { data } = useQuery({
    queryKey: ["scenarios-panel-variant"],
    queryFn: getPanelVariant,
    staleTime: 5 * 60 * 1000,
  });

  if (data?.variant === "v2") {
    return <ScenariosPanelV2 {...props} />;
  }
  return <ScenariosPanel {...props} />;
}
